import React from 'react';
import { Line, DividerText, DividerContainer } from '../styles' 

const Divider = ({ text }) => (
  <DividerContainer>
    <Line />
    <DividerText>{text}</DividerText>
    <Line />
  </DividerContainer>
);

export default Divider;
